import { render, staticRenderFns } from "./userPickerWithNoParents.vue?vue&type=template&id=36e679b8&scoped=true&"
import script from "./userPickerWithNoParents.vue?vue&type=script&lang=js&"
export * from "./userPickerWithNoParents.vue?vue&type=script&lang=js&"
import style0 from "./userPickerWithNoParents.vue?vue&type=style&index=0&id=36e679b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e679b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e679b8')) {
      api.createRecord('36e679b8', component.options)
    } else {
      api.reload('36e679b8', component.options)
    }
    module.hot.accept("./userPickerWithNoParents.vue?vue&type=template&id=36e679b8&scoped=true&", function () {
      api.rerender('36e679b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/userPickerWithNoParents.vue"
export default component.exports